export default class AWSPermissionRequest {

	accountNumber?: string;

	permissionSetARN?: string;

	principalId?: string;

	principalName?: string;

	principalType?: string;

	status?: string;

	constructor(obj: any) {
			Object.assign(this, obj);
		}
}